/**
 * UI関連のユーティリティ関数
 */

import { ref, onMounted, onBeforeUnmount } from 'vue';

/**
 * デバイスタイプを検出するコンポジション関数
 * @param {number} tabletMinWidth タブレット判定の最小幅（デフォルト: 740px）
 * @returns {Object} isMobileリアクティブ参照とその更新メソッド
 */
export function useDeviceDetection(tabletMinWidth = 740) {
  const isMobile = ref(false);
  
  // デバイスタイプを検出する関数
  const checkDeviceType = () => {
    const screenWidth = window.innerWidth;
    isMobile.value = screenWidth < tabletMinWidth;
  };
  
  // リサイズイベントのハンドラー
  const updateDeviceType = () => {
    checkDeviceType();
  };
  
  // コンポーネントマウント時に初期化
  onMounted(() => {
    checkDeviceType();
    window.addEventListener('resize', updateDeviceType);
  });
  
  // クリーンアップ
  onBeforeUnmount(() => {
    window.removeEventListener('resize', updateDeviceType);
  });
  
  return {
    isMobile,
    checkDeviceType,
    updateDeviceType
  };
}

/**
 * 文字列を指定された長さに切り詰める関数
 * @param {string} text 切り詰める文字列
 * @param {number} maxLength 最大長（デフォルト: 20）
 * @param {string} ellipsis 省略記号（デフォルト: '…'）
 * @returns {string} 切り詰められた文字列
 */
export function truncateText(text, maxLength = 20, ellipsis = '…') {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength - 1) + ellipsis;
}

/**
 * モーダル表示時のスクロール制御機能
 * @returns {Object} スクロール制御メソッド
 */
export function useModalScroll() {
  // モーダル表示時にスクロールを無効化
  const disableScroll = () => {
    document.body.style.overflow = 'hidden';
  };
  
  // モーダル非表示時にスクロールを有効化
  const enableScroll = () => {
    document.body.style.overflow = '';
  };
  
  return {
    disableScroll,
    enableScroll
  };
}

/**
 * 広告サイズ計算のためのヘルパー関数
 * @param {boolean} isMobile モバイルかどうか
 * @param {number} defaultMobileSize デフォルトのモバイルサイズ
 * @param {number} defaultDesktopSize デフォルトのデスクトップサイズ
 * @returns {number} 適切なサイズ値
 */
export function calculateAdSize(isMobile, defaultMobileSize = 70, defaultDesktopSize = 120) {
  const screenWidth = window.innerWidth;
  
  if (isMobile) {
    return defaultMobileSize;
  } else if (screenWidth < 900) {
    // タブレットサイズ - 画面に収まるように調整
    return Math.min(Math.floor((screenWidth * 0.9 - 80) / 5), 120);
  } else {
    // 大画面
    return defaultDesktopSize;
  }
}